<template>
  <div class="login">
      <div class="po">
        <div class="loginLogo">
          <img src="../../assets/images/loginLogin.png" alt="">
          <span>WIFFA user system</span>
        </div>
        <div class="login-con">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item prop="realName">
                <el-input
                  placeholder="Your name"
                  v-model="ruleForm.realName"
                  maxlength="30"
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="companyNameEn">
                <el-input
                  placeholder="Company"
                  v-model="ruleForm.companyNameEn"
                  maxlength="60"
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="input4">
                 <el-autocomplete
                   v-model="ruleForm.input4"
                   value-key="enName"
                   :fetch-suggestions="querySearchAsync"
                   placeholder="Location - Select"
                   @select="handleSelect"
                   style="width: 100%;">
                 </el-autocomplete>
              </el-form-item>
              <el-form-item prop="email">
                <el-input
                  placeholder="Email"
                  v-model="ruleForm.email"
                  maxlength="50"
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  placeholder="Password"
                  type="password"
                  v-model="ruleForm.password"
                  maxlength="30"
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="rePassword">
                <el-input
                  placeholder="Re-enter password"
                  type="password"
                  v-model="ruleForm.rePassword"
                  maxlength="30"
                  >
                </el-input>
              </el-form-item>
          </el-form>
          <el-checkbox style="margin-top: 10px;display: block;font-size:11px;line-height: 18px;" v-model="ruleForm.checked">
            By creating an account, <br>
            you agree to Conditions of Use and Privacy Notice.<br>
          </el-checkbox>

          <el-button class="btn" type="primary" @click="successRegister('ruleForm')">Create your account</el-button>
          <el-button type="text" class="register" @click="goLogin">Sign in</el-button>
          <span style="margin-top: 10px;color:#666;display: block;font-size:11px">You need to valid account in your email address!!!</span>
          <!-- <span style="color:red;margin-top: 10px;display:block;">{{msg}}</span> -->
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'registerEn',
  data() {
    return {
       realName: '',
       companyNameEn: '',
       countryId: '',
       input4: '',
       email: '',
       password: '',
       rePassword: '',
       inputB: '',
       checked: true,
       msg: '',
       ruleForm: {
         realName: '',
         companyNameEn: '',
         input4: '',
         email: '',
         password: '',
         rePassword: '',
       },
       rules: {
         realName: [
           { required: true, message: 'Your name', trigger: ['change'] },
         ],
         companyNameEn: [
           { required: true, message: 'Company', trigger: ['change'] }
         ],
         input4: [
           { required: true, message: 'Location - Select', trigger: ['change'] },
         ],
         email: [
           { required: true, message: 'email', trigger: ['change'] }
         ],
         password: [
           { required: true, message: 'password', trigger: ['change'] },
         ],
         rePassword: [
           { required: true, message: 'Re-enter password', trigger: ['change'] }
         ]
       },
    }
  },
  created(){

  },
  mounted() {

  },
   methods: {
     goLogin() {
       this.$router.push({
         name: "loginEn",
         query: {}
       })
     },
     // 国家下拉选(检索)
      querySearchAsync(queryString, cb) {
        var results = [];
        if (queryString) {
          this.$axios.get('/country/list',{
              params: {
                "type": "EN",
                "key": queryString
              }
            })
            .then(response=> {
              if(response.code==0){
                results = response.data;
              }
            })
            .catch(error=> {
              console.log(error);
              this.abnormalSituation()
            })
        } else {
          this.$axios.get('/country/list',{
            params: {
              "type": "EN"
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000);

      },
      handleSelect(item) {
        console.log(item);
        this.countryId = item.countryId;

      },
    // 英文注册
    successRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
           this.$axios.post('/registEn/register', {
             "realName": _this.ruleForm.realName,
             "companyNameEn": _this.ruleForm.companyNameEn,
             "countryId": _this.countryId,
             "email": _this.ruleForm.email,
             "password": _this.ruleForm.password,
             "rePassword": _this.ruleForm.rePassword,
             "agreeFlag": _this.ruleForm.checked==true?1:2 //同意是1，不同意是2
           })
           .then(response=> {
             if(response.code==0){
                this.$alert('Registered successfully！Please verify your email addree', {
                  confirmButtonText: 'Sure',
                  callback: action => {
                  }
              });
               // this.$router.push({
               //   name: "successRegisterEn"
               // })
             }else if(response.code==-1){
                this.$message({
                  type: 'error',
                  message: response.msg
                });
             }
           })
           .catch(error=> {
             console.log(error);
             this.abnormalSituation()
           })
        }
      })

    },
    //  successRegister() {
      //  this.$router.push({
      //    name: "successRegisterMailEn",
      //    query: {

      //    }
      //  })
    //  }
  },
  components: {

  }
}
</script>

<style  scoped>
  /deep/ .el-checkbox__inner{
    margin-top:-20px;
    display:block
  }
  .login{
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/loginBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment:fixed
  }
  .login-con{
    width: 365px;
    padding: 50px 30px 50px 30px;
    background-color: #fff;

  }
  .po{
    position: fixed;
    right: 10%;
    top: 7%;
  }
  .btn{
    width: 100%;
    margin-top: 40px;
  }
  .loginLogo{
    z-index: 9999;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .loginLogo img{
    float: left;
    width: 70px;
    height: 50px;
    margin-left: 30px;
  }
  .loginLogo span{
    float: left;
    color: #fff;
    margin-left: 25px;
    font-size: 26px;
    margin-top: 14px;
    letter-spacing: 1.8px;
  }
  .register{
    display: block;
    width: 56px;
    margin: 5px auto 0!important;
  }
  .xx{
    overflow: hidden;
  }
  .password{
    float: left;
    width: 258px;
    margin-top: 10px;
  }
  .yaz{
    float: left;
    width: 92px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #C9B25F;
    margin-left: 15px;
    margin-top: 10px;
    cursor: pointer;
  }
  .ipt .el-input{
    margin-top: 10px;
  }
  .right-menu{
    float: right;
    height: 100%;
    line-height: 60px;

    .hover-effect {
      cursor: pointer;
      padding: 0 10px;
      transition: background .5s;

      span{
        outline: none;
      }
      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
  .el-dropdown{
    color: #fff;
  }
  /deep/ .el-form-item__label{
      display: none!important;
    }
  /deep/ .el-form-item__content{
    margin-left: 0!important;
  }
  /deep/ .el-form-item{
    margin-bottom: 22px!important;
  }
</style>
